const isLog = process.env.REACT_APP_IS_PROD !== 'true'
const log = {
  info: (...attrs: any[]) => {
    if (isLog) {
      console.log('%caddSafariDatepickerFix:', 'color: #6D1CF0', ...attrs)
    }
  }
}

const setInputsPointerEvents = (
  inputs: NodeListOf<HTMLInputElement>,
  value: string
) => {
  inputs.forEach((input: HTMLInputElement) => {
    let element: HTMLElement
    const textField = input.closest<HTMLDivElement>('.text-field')

    if (textField) {
      element = textField
    } else {
      element = input
    }

    log.info(`set pointerEvents as ${value} for date input`, element)
    element.style.pointerEvents = value
  })
}

export const addSafariDatepickerFix = () => {
  window.addEventListener('click', (e: MouseEvent) => {
    const activeElement = document.activeElement

    if (
      activeElement instanceof HTMLInputElement &&
      activeElement.type === 'text'
    ) {
      log.info('activeElement is text input')
      const dateInputs = document.querySelectorAll<HTMLInputElement>(
        'input[type="date"]'
      )

      setInputsPointerEvents(dateInputs, 'none')

      activeElement.onblur = () => {
        setTimeout(() => {
          setInputsPointerEvents(dateInputs, '')

          activeElement.onblur = null
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/safariDatepickerFix.ts